import { API_BASE_URL } from "../config/api";
import { resolveApiMessage } from "../utils/resolveApiMessage";

export async function fetchProcessSteps(processes = []) {
  const url = new URL("/process-step", API_BASE_URL);

  if (Array.isArray(processes) && processes.length > 0) {
    processes.forEach((process) => {
      url.searchParams.append("process", process);
    });
  }

  const response = await fetch(url.toString());

  const contentType = response.headers.get("content-type");

  if (!response.ok) {
    const text = await response.text();
    throw new Error(`Erro ao buscar etapas: ${response.status} - ${text}`);
  }

  if (!contentType || !contentType.includes("application/json")) {
    const text = await response.text();
    throw new Error(`Resposta não é JSON: ${text}`);
  }

  return response.json();
}